import { CheckCircle2 } from "lucide-react";
import hailmary from "../assets/hailmary.png";
import { useTranslation } from "react-i18next";

const Pillars = () => {

  const { t } = useTranslation();

  const pillars = t("pillars", { returnObjects: true });

  return (
    <div className="mt-10 px-6">
      <h2 className="text-3xl sm:text-5xl lg:text-6xl text-center mt-2 tracking-wide dark:text-white text-black">
        <span className="bg-gradient-to-r from-blue-500 to-orange-800 text-transparent bg-clip-text">
         {t("pillarsTitle")}
        </span>
      </h2>

      <div className="flex flex-col lg:flex-row items-center justify-center lg:gap-2 mt-1">
        {/* Image Section */}
        <div className="w-full lg:w-1/2 flex justify-center">
          <img
            src={hailmary}
            alt="School Pillars"
            className="w-3/4 lg:w-2/3 h-85 object-cover rounded-lg shadow-lg"
          />
        </div>

        {/* Pillars List Section */}
        <div className="w-full lg:w-1/2 mt-10 lg:mt-0">
          {pillars.map((pillar, index) => (
            <div key={index} className="flex items-start mb-10">
              {/* Icon */}
              <div className="text-green-400 bg-neutral-900 dark:bg-neutral-700 h-10 w-10 flex items-center justify-center rounded-full mr-8">
                <CheckCircle2 size={24} className="text-white" />
              </div>
              {/* Text Content */}
              <div>
                <h5 className="text-xl font-semibold dark:text-white text-black">
                  {pillar.title}
                </h5>
                <p className="text-md text-neutral-500 dark:text-neutral-300">
                  {pillar.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Pillars;
